/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { SET_VIDEO_PLAYER_STATE } from './videoplayerstate.types';
import { VideoPlayerStates } from '../../../core/videoplayer/enums';

export const setVideoPlayerStateAction = (playerState: VideoPlayerStates): AnyAction => ({
    type: SET_VIDEO_PLAYER_STATE,
    payload: {
        playerState,
    },
});
